import { useQuery } from '@tanstack/react-query';
import { api, GameStateResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseGameStateReturn {
  gameState: GameStateResponse | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useGameState(keyword: string): UseGameStateReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.gameState.detail(keyword),
    queryFn: () => api.getGameState(keyword),
    enabled: !!keyword,
  });

  return {
    gameState: data?.gameState ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load game state' : null,
    refresh: () => {
      refetch();
    },
  };
}
